import { createSlice } from '@reduxjs/toolkit';
import { getReferenceTypes } from 'ducks/reference-types-list/operators';
import { Slices } from 'ducks/slices';
import { normalizeLookups } from 'ducks/utils';

export type ReferenceTypesListState = ReturnType<typeof normalizeLookups<'reference_type_name', 'reference_type_id'>>;

const initialState: ReferenceTypesListState = [];

const referenceTypesListSlice = createSlice({
  name: Slices.REFERENCE_TYPES_LIST,
  initialState,
  reducers: {
    clearReferenceTypesList: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReferenceTypes.pending, () => {
        return initialState;
      })
      .addCase(getReferenceTypes.fulfilled, (_, { payload }) => {
        return normalizeLookups(payload, 'reference_type_name', 'reference_type_id');
      })
      .addCase(getReferenceTypes.rejected, () => {
        return initialState;
      });
  },
});

export const { clearReferenceTypesList } = referenceTypesListSlice.actions;

export default referenceTypesListSlice.reducer;
